import { combineReducers } from 'redux';
import informations from './informations.reducer';

const reducer = combineReducers({
    informations,
});

export default reducer;
